import { render, staticRenderFns } from "./AddPost.vue?vue&type=template&id=428cd705&scoped=true"
import script from "./AddPost.vue?vue&type=script&lang=js"
export * from "./AddPost.vue?vue&type=script&lang=js"
import style0 from "./AddPost.vue?vue&type=style&index=0&id=428cd705&prod&lang=scss"
import style1 from "./AddPost.vue?vue&type=style&index=1&id=428cd705&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "428cd705",
  null
  
)

export default component.exports